export default __webpack_public_path__ + "static/media/breadcrumb_caret.6eab266d.svg";